module.exports = __webpack_public_path__ + "static/TT-Testfit_Floor22-9dc810538fd04a753b638fc5cfc0e672.pdf";